import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { ReactNode } from 'react';
import type { ColorValue } from 'react-native';
import { Pressable, StyleSheet } from 'react-native';

export function ListingCardHorizontalMenuItem({
  label,
  onPress,
  icon,
  textColor,
}: {
  label: string;
  onPress: () => void;
  icon: ReactNode;
  textColor?: ColorValue | string;
}) {
  return (
    <Pressable style={styles.item} onPress={onPress}>
      <Row alignItems="center" gap="spacing.general.x2">
        {icon}
        <Text style={{ color: textColor }}>{label}</Text>
      </Row>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  item: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
});
